!<!--  -->
<template>
  <div class="">
    <div
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <!-- 搜索栏 -->
      <div
        style="
          display: flex;
          align-items: center;
          width: 800px;

          margin-bottom: 20px;
        "
      >
        <div
          style="
            width: 200px;
            display: flex;
            align-items: center;
            margin-right: 15px;
          "
        >
          <span style="width: 100px"> 目的国 </span>
          <el-input
            clearable
            @clear="clearQuery('country')"
            placeholder="请输入目的国"
            v-model="queryObj.country"
          >
          </el-input>
        </div>

        <div
          style="
            width: 230px;
            display: flex;
            align-items: center;
            margin-right: 15px;
          "
        >
          <span style="width: 100px"> 品名(CN) </span>
          <el-input
            clearable
            @clear="clearQuery('namec')"
            placeholder="请输入品名(CN)"
            v-model="queryObj.namec"
          >
          </el-input>
        </div>
        <div style="width: 230px; display: flex; align-items: center">
          <span style="width: 100px"> 名称(EN) </span>
          <el-input
            clearable
            @clear="clearQuery('namee')"
            placeholder="请输入名称(EN)"
            v-model="queryObj.namee"
          >
          </el-input>
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <el-button @click="getList(1)" type="primary">查询</el-button>
        <el-button @click="getList(2)" type="primary">刷新</el-button>
        <el-button @click="dialogVisible = true" type="primary"
          >批量查询</el-button
        >
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="namec"
          label="品名(CN)"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="namee"
          label="名称(EN)"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsType"
          label="货物类型"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="country"
          label="目的国"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="busType"
          label="业务类型"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="inputer"
          label="录入人"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="inputtime"
          label="录入时间"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="updater"
          label="修改人"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="updatetime"
          label="修改时间"
          min-width="10%"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryObj.curPage"
        :page-sizes="[5, 20, 50, 100]"
        :page-size="queryObj.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <div style="clear: both"></div>
      <!-- 批量查询弹窗 -->
      <!-- Excel上传 -->
      <el-dialog
        title="文件上传"
        :visible.sync="dialogVisible"
        width="40%"
        center
      >
        <el-upload
          style="text-align: center"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          class="upload-demo"
          drag
          :http-request="uploadSectionFile"
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">仅限xls文件</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button
            style="margin-right: 20px"
            size="mini"
            @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-link target="_blank">
            <el-button size="mini" @click="donwLoadTemplate()" type="primary"
              >下载模板</el-button
            >
          </el-link>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      upHeaders: {
        token: "2",
      },

      tableData: [],
      dialogVisible: false,
      queryObj: {
        country: "",
        curPage: 1,
        goodsType: "",
        namec: "",
        namee: "",
        pageSize: 5,
        startIndex: 0,
      },
      total: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 自定义上传
    uploadSectionFile(params) {
      // console.log(params);
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/busFbx/getGoodsCategory`, form, { responseType: "arraybuffer" })
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "分类模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    donwLoadTemplate() {
      this.axios
        .get(`/busFbx/getFBXGoodsCategoryTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "分类模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 上传前
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限尾缀为xls的文件,请检查");
        return false;
      }
    },
    handleError(err) {
      // console.log(err);
      this.$message.info(err.data);
    },
    handleSuccess(response) {},

    clearQuery() {
      this.getList();
    },
    handleSizeChange(val) {
      this.queryObj.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.queryObj.curPage = val;
      this.getList();
    },
    getList(type) {
      if (type === 1) {
        this.queryObj.curPage = 1;
      }
      if (type === 2) {
        // this.queryObj.curPage = 1;
      }
      this.axios
        .post(`/busFbx/getDatGoodsCategoryList`, this.queryObj)
        .then((res) => {
          if (res.data.code == 200) {
            //   console.log(res.data);
            this.tableData = res.data.data.datalList;
            this.total = res.data.data.totalCounts;
            // this.total = res.data.data.totalCounts
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/Classify.vue